import { render, staticRenderFns } from "./AssignDialog.vue?vue&type=template&id=f49d6cf8&scoped=true"
import script from "./AssignDialog.vue?vue&type=script&lang=js"
export * from "./AssignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49d6cf8",
  null
  
)

export default component.exports